import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import moment from "moment";
import "@/theme/element-variables.scss";
import { bus } from "@/utils";
import { isMobile } from "@/utils/is";

Vue.prototype.$moment = moment;
Vue.prototype.$bus = bus;
Vue.config.productionTip = false;
Vue.use(ElementUI);

if (isMobile()) {
  window.location.href = "http://m.hxylt.org.cn/pages/teacher_platform.html";
}

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
